module.exports = __webpack_public_path__ + "img/image004.b455cc51.png";